import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";
import { page } from "../app/schema";

export const GET_PAGES = "GET_PAGES";
export const GET_PAGES_SUCCESS = "GET_PAGES_SUCCESS";
export const GET_PAGES_ERROR = "GET_PAGES_ERROR";

export const PATCH_PAGE = "PATCH_PAGE";
export const PATCH_PAGE_SUCCESS = "PATCH_PAGE_SUCCESS";
export const PATCH_PAGE_ERROR = "PATCH_PAGE_ERROR";

export const DELETE_PAGE = "DELETE_PAGE";
export const DELETE_PAGE_SUCCESS = "DELETE_PAGE_SUCCESS";
export const DELETE_PAGE_ERROR = "DELETE_PAGE_ERROR";

// Requests
const getPagesGet = (fetch, apiHost, accessToken, meta) =>
  fetch(
    `${apiHost}/v1/pages?limit=${meta.limit}&offset=${meta.currentPage *
      meta.limit}`,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      },
      method: "GET"
    }
  ).then(response => {
    return validateResponse(response, {});
  });

const patchPage = (fetch, apiHost, accessToken, uid, data) =>
  fetch(`${apiHost}/v1/pages/${uid}`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "PATCH"
  }).then(response => {
    return validateResponse(response, {});
  });

const deletePage = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/pages/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "DELETE"
  }).then(response => {
    return validateResponse(response, {
      validation_error: {
        msg: "Nie można usunąć danych strony, ponieważ są one używane przez inne zasoby.",
        field: "all"
      }
    });
  });

// Actions
export function getPages(meta) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_PAGES],
    payload: {
      promise: getPagesGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        meta
      )
        .then(data => {
          return normalize(data, { pages: arrayOf(page) });
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function updatePage(data, uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [PATCH_PAGE],
    payload: {
      promise: patchPage(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        data
      )
        .then(data => {
          return normalize(data, page);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function removePage(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [DELETE_PAGE],
    payload: {
      promise: deletePage(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      }),
      data: {
        uid
      }
    }
  });
}



// WEBPACK FOOTER //
// ./src/common/pages/actions.js